module.exports = __webpack_public_path__ + "static/media/signal-slash.85d96aee.svg";